export default __webpack_public_path__ + "static/media/sportya_og.e25eb808.jpg";